export enum SelectionTypeEnum {
    FIGURE = "FIGURE",
    LINK = "LINK",
    MYTH = "MYTH"
}
